import React from 'react';

type Props = {
  targetRect: DOMRect | null;
  padding?: number;
  radius?: number;
  opacity?: number;
  onClick?: () => void;
};

const TourOverlay: React.FC<Props> = ({
  targetRect,
  padding = 6,
  radius = 6,
  opacity = 0.5,
  onClick,
}) => {
  const maskId = 'tour-driver-spotlight-mask';

  return (
    <svg
      style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 999998,
        pointerEvents: 'auto',
      }}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <defs>
        <mask id={maskId}>
          {/* White = show overlay; black cut-out = transparent spotlight */}
          <rect width="100%" height="100%" fill="white" />
          {targetRect && (
            <rect
              x={targetRect.left - padding}
              y={targetRect.top - padding}
              width={targetRect.width + padding * 2}
              height={targetRect.height + padding * 2}
              rx={radius}
              ry={radius}
              fill="black"
            />
          )}
        </mask>
      </defs>

      <rect width="100%" height="100%" fill={`rgba(0,0,0,${opacity})`} mask={`url(#${maskId})`} />
    </svg>
  );
};

export default TourOverlay;
